/**
 * Clears session storage data for the given keys
 */
export const clearSessionData = (sessionKeys: { [key: string]: string }) => {
  Object.values(sessionKeys).forEach((key) => sessionStorage.removeItem(key));
};

/**
 * Retrieves and parses session storage data by key
 * @param key - The session storage key
 */
export const getSessionData = <T>(key: string): T | undefined => {
  const json = sessionStorage.getItem(key);
  return json ? (JSON.parse(json) as T) : undefined;
};

/**
 * Stores data in session storage as JSON string
 * @param key - The session storage key
 * @param value - The data to store
 */
export const setSessionData = <T extends object = object>(key: string, value: T) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};
